module.exports = __webpack_public_path__ + "static/img/log.149d48a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/log.png
// module id = 5vAY
// module chunks = 1